import { get } from '../axiosprovider';

export interface IMapsAuth {
	token: string;
	clientId: string;
}

const getMapsAuth = (): Promise<IMapsAuth> => get('/api/maps/token') as unknown as Promise<IMapsAuth>;

export { getMapsAuth };
